export default "__VITE_ASSET__BRql7Vsl__"